import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicationClientCommonModule, MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { CenteredScrollableContentModule } from 'src/tmc-common/widgets/terminal/centered-scrollable-content/centered-scrollable-content.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VisitorTypeRelatedImageComponent } from './component/visitortype-related-image.component';


@NgModule({
  declarations: [
    VisitorTypeRelatedImageComponent
  ],
  imports: [
    CommonModule,
    CenteredScrollableContentModule,
    DictionaryModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
  ]
})
export class VisitorTypeRelatedImageModule { }
